import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Base64 } from "js-base64";

const RazorpayCheckout = () => {
  const { orderId, data } = useParams();

  // ✅ Detect iOS safely (no async issue)
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  useEffect(() => {
    if (!orderId || !data) return;

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => openCheckout();
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [orderId, data]);

  const toBase64 = (str) => Base64.encode(str);
  const fromBase64 = (base64) => Base64.decode(base64);

  const redirect = (type, responseData = null) => {
    let baseUrl;

    if (isIOS) {
      baseUrl = `mony://${type}?pg=razorpay`;
    } else {
      baseUrl = `https://havemony.com/${type}?pg=razorpay`;
    }

    if (responseData) {
      const encoded = toBase64(JSON.stringify(responseData));
      baseUrl += `&data=${encoded}`;
    }

    window.location.href = baseUrl;
  };

  const openCheckout = () => {
    try {
      const decodedData = fromBase64(data);
      const dataObj = JSON.parse(decodedData);

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY, // ✅ make sure env variable is correct
        currency: "INR",
        name: "Mony UPI",
        description: "Fund Load",
        image: "https://havemony.com/mony_logo_new.svg",
        order_id: orderId,

        handler: function (response) {
          redirect("loaderSuccess", response);
        },

        modal: {
          ondismiss: function () {
            redirect("loaderDismiss");
          },
        },

        prefill: {
          name: dataObj.name,
          email: dataObj.email,
          contact: dataObj.mobileNumber,
          method: "card",
        },

        notes: {
          address: "Fund Load",
        },

        theme: {
          color: "#0458ff",
        },

        config: {
          display: {
            hide: [
              { method: "upi" },
              { method: "netbanking" },
              { method: "wallet" },
              { method: "emi" },
            ],
            sequence: ["block.banks"],
            preferences: {
              show_default_blocks: true,
            },
          },
        },
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function (response) {
        if (response?.error?.description === "Payment cancelled!") {
          redirect("loaderDismiss");
        } else {
          redirect("loaderFailure", response);
        }
      });

      rzp.open();
    } catch (err) {
      console.error("Checkout error:", err);
      redirect("loaderFailure");
    }
  };

  return null; // no UI needed
};

export default RazorpayCheckout;